<template>
  <div class="snow-data-table-dropdown">
    <snow-table-dropdown-popper
      trigger="clickToToggle"
      :disabled="disabled"
      :options="popperOptions"
    >
      <div slot="reference" ref="dropdownButton">
        <snow-button
          size="md"
          variant="borderless"
          color="neutral"
          class="dropdown-button"
          icon="ph ph-dots-three"
          :disabled="disabled"
        />
      </div>

      <div slot="default" class="snow-table-dropdown-options-dropdown">
        <snow-button
          v-for="(option, i) in options"
          align-left
          variant="borderless"
          :key="i"
          :class="option.class"
          :text="option.label"
          :color="option.color || 'neutral'"
          @click="selectOption(option)"
        />
      </div>
    </snow-table-dropdown-popper>
  </div>
</template>

<script>
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  components: { "snow-table-dropdown-popper": Popper },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    popperOptions() {
      return {
        placement: "left",
        modifiers: {
          offset: {
            offset: "4px,0"
          }
        }
      };
    }
  },
  methods: {
    selectOption(option) {
      this.$refs.dropdownButton.click();
      this.$emit("click", option, this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors";
.snow-data-table-dropdown {
  .dropdown-button {
    border-radius: 50%;
    width: 22px;
    height: 22px;
    padding: 0 !important;
  }
  .snow-table-dropdown-options-dropdown {
    padding: 8px;
    z-index: 100;
    overflow: hidden;
    border-radius: 4px;
    border: 1px solid rgba(215, 215, 215, 0.48);
    background: rgba(255, 255, 255, 0.64);
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
    backdrop-filter: blur(12px);

    display: flex;
    flex-direction: column;
  }
}
</style>
